import Vue from 'vue';

Vue.component('not-found-component', {
    props: {
        defaultSearchUrl: {
            type: String
        }
    },

    data() {
        return {
            searchQuery: '',
        }
    },

    mounted() { },

    methods: {
        handleSearch(e) {
            if (e.keyCode !== 13 || e.which !== 13) {
                return;
            }

            if (!this.defaultSearchUrl || this.searchQuery.length === 0) {
                e.preventDefault();
                return;
            }

            window.location = `${this.defaultSearchUrl}?q=${this.searchQuery}`;
        }
    },

    beforeDestroy() { }
});
